/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExhibitionPageTransitionOptionsMorphView
 */
export interface ExhibitionPageTransitionOptionsMorphView {
    /**
     * 
     * @type {string}
     * @memberof ExhibitionPageTransitionOptionsMorphView
     */
    sourceId: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitionPageTransitionOptionsMorphView
     */
    targetId: string;
}

export function ExhibitionPageTransitionOptionsMorphViewFromJSON(json: any): ExhibitionPageTransitionOptionsMorphView {
    return ExhibitionPageTransitionOptionsMorphViewFromJSONTyped(json, false);
}

export function ExhibitionPageTransitionOptionsMorphViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExhibitionPageTransitionOptionsMorphView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceId': json['sourceId'],
        'targetId': json['targetId'],
    };
}

export function ExhibitionPageTransitionOptionsMorphViewToJSON(value?: ExhibitionPageTransitionOptionsMorphView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sourceId': value.sourceId,
        'targetId': value.targetId,
    };
}


